import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import db from './db';
import HubPopup from "./HubPopup";
import Popup from "./Popup";
import FactoryDevices from "./FactoryDevices"
import GenerateHubRecords  from "./GenerateHubRecords"
import { Tab, Tabs, TabPanel, TabList } from 'react-tabs';
var functions = require("./functions.js");

// HubTable component
export default class HubTable extends React.Component {

    messagesEnd=undefined;
    default_ip_address="192.168.10.";
    default_ip_port="80";

    // constructor
    constructor(props) {
        super(props);

        this.columns=[
            { key: 'facility_name', title:"Facility", width :18 }
            , { key: 'display_name', title:"name", width :18 }
            , { key: 'is_online', title:"online", width :18 }
            , { key: 'last_seen', title:"Last Seen", width :18, render:functions.renderDateInTable }
            , { key: 'hostname', title:"Host Name", width :18 }
            , { key: 'system_version', title:"System Version", width :5 }
            , { key: 'batt_level', title:"Battery Level", width :5 }
            , { key: 'sys_voltage', title:"System Voltage", width :5 }
            , { key: 'system_load_time', title:"System Load Time", width :5 }
            , { key: 'id', title:"id", width :5 }
        ];
        if(functions.isMobile()){
            this.columns=[
                { key: 'hostname', title:"Hub", width :100, render: this.renderHubForMobile }
            ];
    
        }

        // initalize state
        this.state = {
            hubs:[],
            hub:this.getEmptyHub(),
            hubVisible:false,
            createHubVisible:false,
            initHostName:this.props.initHostName
            ,postHubModified : false
            ,postHub : this.getEmptyHub()
            ,tabIndex:0 
        }
        this.filterRef = React.createRef();
        this.addHubRef = React.createRef();
    }
    componentDidMount() {
        this.filterRef.current.focus();
        if(this.state.initHostName){
            setTimeout(function() { //Start the timer
                this.queryHubs();  // wait to query hub
            }.bind(this), 2000)            
        }
    }
    inputFilterKeyUp(event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          this.queryHubs();
        }
    }
    // render
    render() {

        return (
            <div>
                <Tabs onSelect={(index) => this.selectTab(index)}>
                    <TabList>
                        <Tab>Hubs</Tab>
                        <Tab>Board Inventory</Tab>
                    </TabList>
                    <TabPanel>
                    <div>
                            Search:<input id="search_column" className='input-filter' onKeyUp={this.inputFilterKeyUp.bind(this)} ref={this.filterRef} defaultValue={this.state.initHostName} />&nbsp;
                            <button onClick={()=>{this.queryHubs()}} >Query Hubs</button>&nbsp;
                            <button onClick={()=>{this.openCreateHub()}}>Create Hub</button>
                        </div>
                        <div>
                            <TableScrollbar height="80vh">
                                <ErrorBoundary>
                                    <Table columns={this.columns} 
                                            dataSource={this.state.hubs} 
                                            onRowClick={this.editHub.bind(this)} 
                                            />
                                </ErrorBoundary>
                            </TableScrollbar>
                        </div>
                        <div>
                            <Popup
                                trigger={this.state.createHubVisible
                                }
                            >
                                <div className="float-left" >
                                    <h3>Create Hub</h3>
                                    <table>
                                        <tr>
                                            <td width="40%">
                                                Host Name:<input id="hostname" name="hostname" className='input-filter'  onChange={this.updateHubInputValue.bind(this)} ref={this.addHubRef}/>(hub??? must be lower case and no undercore or special characters)<br />
                                                IP Address:<input id="processor_ip_address" name="processor_ip_address" className='input-filter' defaultValue={this.default_ip_address}  onChange={this.updateHubInputValue.bind(this)}/><br />
                                                Port:<input id="processor_app_port" name="processor_app_port" className='input-filter' defaultValue={this.default_ip_port}  onChange={this.updateHubInputValue.bind(this)}/><br />
                                                Model:<input id="model" name="model" className='input-filter'   onChange={this.updateHubInputValue.bind(this)}/> (w2000/lea)<br />
                                                ICB Number:<input id="icb_Number" name="icb_Number" className='input-filter'   onChange={this.updateHubInputValue.bind(this)}/><br />
                                                ICB Version:<input id="icb_version" name="icb_version" className='input-filter'  onChange={this.updateHubInputValue.bind(this)}/><br />
                                                ICB Date Shipped:<input id="icb_date_shipped" name="icb_date_shipped" className='input-filter'  onChange={this.updateHubInputValue.bind(this)}/><br />
                                                Number Of Batteries:<input id="number_of_batteries" name="number_of_batteries" className='input-filter' defaultValue={"4"} onChange={this.updateHubInputValue.bind(this)} type='number' /><br />
                                                <button onClick={()=>{this.saveNewHub()}}>Save</button>
                                                <button onClick={()=>{this.setState({createHubVisible:false})}}>Cancel</button>
                                            </td>
                                            <td width="60%">
                                                <FactoryDevices 
                                                    securityObject={this.props.securityObject}
                                                    buttonClick={[
                                                        this.factoryDeviceOnRowClick.bind(this)
                                                        , this.factoryDeviceOnRowClick.bind(this)
                                                    ]}
                                                    buttonTitle={[
                                                        "Commercial"
                                                        ,"lea"
                                                    ]}
                                                ></FactoryDevices>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </Popup>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <GenerateHubRecords 
                                securityObject={this.props.securityObject}
                        ></GenerateHubRecords>
                    </TabPanel>
                </Tabs>
                <div>
                <HubPopup
                    hubId={this.state.hub.id}
                    visible={this.state.hubVisible}
                    securityObject={this.props.securityObject}
                    onCloseHubPopup={this.closeHubPopup.bind(this)}
                >
                </HubPopup>
            </div>
            </div>
        );
    }

    selectIP(rowData){
        //window.alert(JSON.stringify(rowData))
        document.getElementById("processor_ip_address").value=rowData.ip;
        document.getElementById("processor_app_port").value=rowData.port;
        if(rowData.port===80){
            document.getElementById("model").value="w10";
        } else {
            document.getElementById("model").value="w100";
        }
    }
    // load the table
    queryHubs(params){
        if(document.getElementById("search_column")){
            db.getHubs( 
                document.getElementById("search_column").value
                ,""
                ,""
                ,""
                ,this.props.securityObject
                ,(hubList) => { 
                    if(this.state.initHostName && hubList.length>0){
                        this.editHub(hubList[0],0);
                    }
                    this.setState({
                        hubs : hubList,
                        initHostName:undefined
                    })
                }
                ,params
            )
        }
    }
    // edit a hub
    editHub( rowData, rowIndex ){
        this.setState({
            hub:rowData
            , hubVisible:true
        })
    }
    // close the hub popup
    closeHubPopup(){
        this.setState({
            hubVisible:false,
            hub:this.getEmptyHub()
        });
        this.selectTab();
    }
    ipTablet(){
        let host=document.getElementById("ip_address").value;
        let url="http://" + host+":"+document.getElementById("ip_port").value;
        functions.openWindow( url );
    }
    ipSSH(){
        let host=document.getElementById("ip_address").value;
        let url="ssh://pi@" + host;
        functions.openWindow( url );
    }
    openCreateHub(){
        this.setState(
            {
                createHubVisible:true,
                postHub : this.getEmptyHub() 
            })
        //this.addHubRef.current.focus();

    }
   // update the postHub object with values that were edited on screen
   updateHubInputValue(evt){
        let postHub=this.state.postHub;
        postHub[evt.currentTarget.name] = evt.currentTarget.value;         
        this.setState({
            postHubModified:true,
            postHub: postHub
        });  
     }     

    saveNewHub(){
        db.saveData( this.props.securityObject
            , this.state.postHub
            ,"api/updateHub"
            , this.setHubSaved());
    }  
    saveHub(){
    }
    setHubSaved(){
        document.getElementById("search_column").value=this.state.postHub.hostname;
        //document.getElementById("display_name").value="";
        this.setState({
            postHubModified:false,
            createHubVisible:false,
            postHub:{}
        });
        setTimeout(function() { //Start the timer
            this.queryHubs();  // wait to query hub
        }.bind(this), 2000)  
    }
    getEmptyHub(){
        let res=Object.assign({}, HubPopup.emptyHub);
        res.processor_ip_address=this.default_ip_address;
        res.processor_app_port=this.default_ip_port;
        return res;
    }
    factoryDeviceOnRowClick(title, rowData){
        //alert(`${rowData.ip}`);
        let postHub=this.state.postHub;
        
        // set IP address
        document.getElementById("processor_ip_address").value=rowData.ip;
        postHub.processor_ip_address = rowData.ip;


        // set hostname suggestion, model
        if(title==="lea"){
            document.getElementById("hostname").value='w10'+rowData.mac.replaceAll(":","").substring(6).tolower();
            document.getElementById("model").value="lea";
            document.getElementById("number_of_batteries").value="2";
        } else {
            document.getElementById("hostname").value="hub";
            document.getElementById("model").value="w2000";
            document.getElementById("number_of_batteries").value="4";
        }
        postHub.hostname = document.getElementById("hostname").value;         
        postHub.model = document.getElementById("model").value;         
        postHub.number_of_batteries = document.getElementById("number_of_batteries").value;
        // set
        this.setState({
            postHubModified:true,
            postHub: postHub
        });        
    }
    selectTab(index){
        if(index!==undefined){
            this.setState({
                tabIndex:index
            })
        } else {
            index=this.state.tabIndex;
        }
        try {
            if(index===0){this.queryHubs()}
        } catch (ex){

        }
    }
    queryData() {
        this.searchTableRef.current.queryData();
    }
    renderHubForMobile(cellData, rowData, rowIndex){
        let out=rowData.hostname +" - "+ rowData.display_name;
        let array=[];
        let btnPlus=React.createElement(
            'span'
            ,{ }
            ,out);
        array.push(btnPlus);
        // return div
        let div=React.createElement('div',{}, array );
        return div;  
    }
}